<nb-select [(selected)]="selectedOption" [placeholder]="placeHolder"  (selectedChange)="changeContent($event)" size="small" fullWidth>
    <nb-option *ngFor="let selectOption of selectOptions" [value]="selectOption">{{ selectOption.description }}</nb-option>
</nb-select>
